// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FWm_2","rootMobile":"styles_rootMobile__11w6M"};